import React, {useState, useEffect} from "react";

import APIClient from "../client";
import config from "../config.js";
import AuthNavbar from "../components/Navbars/AuthNavbar.js";
import MapChart from "../components/Charts/MapChart.js";

import '../assets/styles/App.css';
import "@fontsource/montserrat";
import CardError from "../components/Cards/CardError";


const client = new APIClient(config);


export default function PredictionOpportunity(props) {
    const [mapData, setMapData] = useState(null);
    const [opportunityData, setOpportunityData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        try {
            fetchMapDisplay();
            fetchMapOpportunity();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchMapDisplay = () => {
        client.getAvailableMapDisplays().then((data) => {
            setMapData(data['data']['data']);
        });
    };

    const fetchMapOpportunity = () => {
        client.getFunderHeadroom().then((data) => {
            setOpportunityData(data['data']['data']);
        });
    };

    document.title = "Opportunity Overview";

    return (
        <>
            <section>
                <AuthNavbar />
            </section>

            <section className="relative grad-1 pb-20">
                <div className="container relative mx-auto pt-12 px-4 w-10/12">
                    <h2 className="text-36 text-yellow mb-6">Current Opportunity</h2>
                    <p className="text-20-30 text-white">
                        Select a country with available opportunities.
                    </p>
                    <div>
                        {loading && (
                            <div className="text-xl text-yellow font-medium">Loading...</div>
                        )}
                        {error && <CardError message={error} />}
                        {mapData && (
                        <MapChart
                            mapdata={mapData}
                            opportunitydata={opportunityData}
                        />
                            )
                        }
                    </div>
                </div>

            </section>
        </>
    );


}